export default {
  heading: 'Teko, serif',
  body: 'Source Sans Pro, sans-serif',
  monospace: 'monospace',
  display: 'Teko, serif',
  googleFonts: ['Teko:300,400,500,600,700', 'Source Sans Pro:300,400,500,600,700']
  // customFamilies: [''],
  // customUrls: [''],
}
